import { useMemo } from 'react';

export const useGetButtonTitles = ({ mode }: { mode: 'create' | 'duplicate' | 'edit' }) =>
  useMemo(() => {
    switch (mode) {
      case 'create':
        return { cancelTitle: 'Back', submitTitle: 'Create' };
      case 'duplicate':
      case 'edit':
        return { cancelTitle: 'Close', submitTitle: 'Save' };
    }
  }, [mode]);
